import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 获取优惠券池列表
export function listCouponShopPool(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/couponShopPool.listCouponShopPool',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存优惠券池
export function saveCouponShopPool(data) {
  data.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/couponShopPool/saveCouponShopPool',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新优惠券池
export function updateCouponShopPool(data) {
  data.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/couponShopPool/updateCouponShopPool',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除优惠券池
export function deleteCouponShopPool(data) {
  data.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/couponShopPool/deleteCouponShopPool',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取所有优惠券池
export function listCouponPool(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/couponPool/listCouponPool',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}